import { mui, React, ui } from '_core';

import { TABLE_ROW_HEIGHT } from '@local/finsera-core/src/theme/layout-size';

import { columns } from './config';
import { FixedCostContext } from './fixed-costs-context';

const FixedCostsTable = () => {
  const fixedCostsContext = React.useContext(FixedCostContext);
  const { rows } = fixedCostsContext;
  const [, setContainerHeight] = React.useState(undefined);
  const container = React.createRef<HTMLDivElement>();

  React.useEffect(() => {
    if (container.current) {
      setContainerHeight(container.current.offsetHeight);
    }
  }, [rows]);

  return (
    <mui.core.Box
      mb={3}
      id="fixed-costs-table"
      style={{ height: '100%', width: '100%' }}
      {...({ ref: container } as any)}
    >
      <ui.FinDataGrid
        density="standard"
        rows={rows.rows || []}
        columns={columns}
        autoHeight
        disableColumnMenu
        slots={{
          toolbar: null,
        }}
        rowHeight={TABLE_ROW_HEIGHT.sm}
        columnHeaderHeight={TABLE_ROW_HEIGHT.sm}
      />
    </mui.core.Box>
  );
};

export default FixedCostsTable;
